import { ICTask } from '@Helper/Interfaces';
import React, { FC } from 'react';
import MoreMenu from '../components/MoreMenu';

type IProps = {
  data: any;
  updateTaskProperty?: (taskId: string, property: string, value: any) => any;
  updateTaskSection?: (currentTask: ICTask, sectionId: string) => void;
  deleteTask?: (task: ICTask, stopDelete?: string) => void;
  renameTask?: (task: ICTask) => void;
};

const OperationCell: FC<IProps> = ({
  data,
  updateTaskProperty,
  updateTaskSection,
  deleteTask,
  renameTask,
}) => {
  return (
    <MoreMenu
      task={data.data.data}
      updateTaskSection={updateTaskSection}
      updateTaskProperty={updateTaskProperty}
      deleteTask={deleteTask}
      renameTask={renameTask}
    />
  );
};

export default OperationCell;
